import React from "react";
import { Tag as BlueprintTag } from "@blueprintjs/core";
import classNames from "classnames";
import TextTruncate from "../TextTruncate";
import * as styles from "./styles.module.scss";
const Tag = ({ name, onRemove, showRemoveIconOnHover = true, className, title, prefix, inverted = false, }) => (React.createElement(BlueprintTag, { className: classNames(styles.tag, {
        [styles.showRemoveIconOnHover]: showRemoveIconOnHover,
        [styles.inverted]: inverted,
        [styles.withoutRemove]: !onRemove,
    }, className), multiline: true, onRemove: onRemove },
    prefix,
    React.createElement(TextTruncate, { text: name, title: title })));
export default Tag;
